<template>
	<div class="row" v-show="!loading">
		<div class="col-lg-6">
			<profile-form :profile.sync="profile"></profile-form>
		</div>
		<div class="col-lg-6">
			<div class="box">
				<div class="box-header">
					<h2 class="box-title">Profiles</h2>
				</div>
				<div class="box-body">
					<div class="alert alert-info">
						<i class="fa fa-info-circle"></i> Drag and drop your profiles list into your preferred order.
					</div>

					<ol class="sortable">
						<li v-for="profile in profiles" :id="`profile_${profile.id}`" @click.stop="edit(profile)" :class="{'active': profile.id == activeProfile.id}">
							<div>{{ profile.name }}</div>
						</li>
					</ol>

					<hr />

					<a @click="createNewProfile" class="btn btn-sm btn-success"><i class="fa fa-plus"></i> Create New Profile</a>
					<label for="upload-temperature-profile" class="btn btn-sm btn-success"><i class="fa fa-file-archive-o"></i> Import Temperature Profile</label>
					<input type="file" name="temperature_profile" id="upload-temperature-profile" accept=".csv">

				</div>
			</div>
		</div>
	</div>
</template>

<style>
	#upload-temperature-profile {
		opacity: 0;
	}
</style>

<script>
	import ProfileForm from './profile-form'
	import { Profiles as ProfileActions, App as AppActions } from 'vx/actions'
	import { site, profile as activeProfile, profiles, loading, simulatorSetup } from 'vx/getters'
	import Notify from 'utils/notify'
	import Alert from 'utils/alert'

	export default {
		components: {
			ProfileForm
		},

		vuex: {
			actions: {
				all: ProfileActions.all,
				clear: ProfileActions.clear,
				edit: ProfileActions.edit,
				reposition: ProfileActions.reposition,
				setTitle: AppActions.title
			},
			getters: {
				loading,
				site,
				activeProfile,
				profiles,
				simulatorSetup
			}
		},

		watch: {
			activeProfile() {
				this.profile = $.extend({}, this.activeProfile);
			}
		},

		data() {
			return {
				profile: {
					id: null,
					name: '',
					profile: 0,
					duration: 0,
					type: 1,
					dailyData: {
						data: []
					}
				}
			};
		},

		route: {
			activate() {
				this.$dispatch('loading');
			},

			data() {
				this.all(this.site.id).then(() => {
					this.$dispatch('loaded');
				});
			}
		},

		ready() {
			this.setTitle('Ferment Profiles');

			$('.sortable').nestedSortable({
				handle: 'div',
				items: 'li',
				isTree: true,
				maxLevels: 2,
				toleranceElement: '> div',
				protectRoot: true,
				relocate: event => {
					let hierarchy = $('.sortable').nestedSortable('toHierarchy', { startDepthCount: 0 });

					hierarchy.forEach(parent => {
						delete parent['nestedSortable-item'];
					});

					this.reposition(this.site.id, hierarchy).then(response => {
						Notify.success('Profiles have been sorted.', { timeout: 2000 });
					});
				}
			});

			$('#upload-temperature-profile').on('change', this.handleTemperatureProfileSelect);
		},

		methods: {
			createNewProfile() {
				this.clear();

				$('input[id=name]').focus();
			},

			handleTemperatureProfileSelect(event) {
				let file = event.target.files[0],
					reader = new FileReader();

				reader.readAsText(file);

				this.clear();

				reader.onload = event => {
					let dailyData;

					try {
						dailyData = $.csv.toObjects(event.target.result);
					} catch (e) {
						this.failedTemperatureProfileImport('Failed to import temperature profile. The selected file was not a valid exported temperature profile.');

						return;
					}

					if (dailyData.length > 1) {
						let dayDifference = parseFloat(dailyData[1].day) - parseFloat(dailyData[0].day);

						// If the day difference is 0.5 then we need to set the profile type to either
						// red or white, whichever has a measuring frequency of twice.
						if (dayDifference == 0.5) {
							if (this.simulatorSetup.red_sampling_freq) {
								this.profile.type = true;
							} else if (this.simulatorSetup.white_sampling_freq) {
								this.profile.type = false;
							} else {
								this.failedTemperatureProfileImport();

								return;
							}
						// Same as above, we need to select type based on the day difference and the
						// measuring freq.
						} else if (dayDifference == 1) {
							if (! this.simulatorSetup.white_sampling_freq) {
								this.profile.type = false;
							} else if (! this.simulatorSetup.red_sampling_freq) {
								this.profile.type = true;
							} else {
								this.failedTemperatureProfileImport();

								return;
							}
						// If we have an unknown day difference then we can't import this profile.
						} else {
							this.failedTemperatureProfileImport('Failed to import temperature profile. The selected file was not a valid exported temperature profile.');

							return;
						}
					}


					this.profile.dailyData.data = [];

					for (let i = 0; i < dailyData.length; ++i) {
						this.profile.dailyData.data.push({
							id: null,
							day: dailyData[i].day,
							baume: null,
							temp: dailyData[i].temp,
							comments: dailyData[i].comments,
							action: {
								data: {
									acid: dailyData[i].acid,
									aeration: dailyData[i].aeration,
									agitator: dailyData[i].agitator,
									dap: dailyData[i].dap,
									pump_over: dailyData[i].pump_over,
									reinoculate: dailyData[i].reinoculate,
									juice: dailyData[i].juice
								}
							},
							analysis: {
								data: {
									cell_count: dailyData[i].cell_count,
									fs02: dailyData[i].fs02,
									gf: dailyData[i].gf,
									ntu: dailyData[i].ntu,
									ph: dailyData[i].ph,
									ta: dailyData[i].ta,
									ts02: dailyData[i].ts02
								}
							}
						});
					}

					Notify.success('Temperature profile imported.')
				};
			},

			failedTemperatureProfileImport() {
				Alert.error({text: 'Failed to import temperature profile. Please check the sampling frequency of the exported profile.', title: 'Invalid File'});
			}
		}
	}
</script>



// WEBPACK FOOTER //
// index.vue?12e447dc